export default __webpack_public_path__ + "static/media/illustration-elements_icon-youtube.9021e8d3.svg";